<template>
  <v-app>
    <Views />
  </v-app>
</template>

<script>
import Views from '../components/Views'

export default {
  components: {
    Views,
  },
  data: () => ({
    //
  }),
};
</script>
